import { BotIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";

import { dates } from "@/lib/dates";
import { scheduledAgentMessages } from "@/lib/scheduledAgentMessages";
import { ScheduledAgentMessageResponse } from "@/types";

// The agent's next queued send, shown as a dashed outbound bubble so the
// staffer can read the exact text before it goes out.
export const ScheduledAgentMessage = ({
  scheduledMessage,
}: {
  scheduledMessage: ScheduledAgentMessageResponse;
}) => (
  <Row className="w-full shrink-0 justify-end pb-3 pr-2">
    <Column className="ml-[10%] items-end gap-0.5">
      {/* Slightly roomier than a delivered bubble: a dashed outline reads
          tighter than a filled shape at the same padding. */}
      <Column className="relative rounded-2xl border border-dashed border-blue-700 bg-transparent px-5 py-3">
        <Row className="absolute -top-2 right-1 z-10 h-5 w-5 items-center justify-center rounded-full bg-white text-primary-700 ring-1 ring-primary-300">
          <BotIcon className="h-3 w-3" />
        </Row>
        <Text className="whitespace-pre-wrap text-sm font-normal text-slate-950 [overflow-wrap:anywhere]">
          {scheduledMessage.body}
        </Text>
      </Column>
      <Text className="px-1 text-xs font-medium text-slate-500">
        {dates.formatTime(scheduledMessage.scheduledFor)} ·{" "}
        {scheduledAgentMessages.stepLabel(scheduledMessage)}
      </Text>
    </Column>
  </Row>
);
